import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { UserComponent } from './user/user.component';
import { TablesComponent } from './tables/tables.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import { NichesComponent } from 'app/niches/niches.component';
import { QuestionsComponent } from 'app/questions/questions.component';
import { RegularComponent } from 'app/admin/regular/regular.component';
import { SatisfactionComponent } from 'app/admin/satisfaction/satisfaction.component';
import { SurveyComponent } from 'app/admin/survey/survey.component';
import { AssessmentsComponent } from 'app/assessments/assessments.component';
import { HelpComponent } from 'app/help/help.component';
import { ClientAssessmentsComponent } from 'app/client/client-assessments/client-assessments.component';
import { ClientReportsComponent } from 'app/client/client-reports/client-reports.component';
import { UnassignedAssessmentsComponent } from 'app/coach/unassigned-assessments/unassigned-assessments.component';
import { InstructionsComponent } from 'app/client/instructions/instructions.component';
import { RaterAssessmentInstructionsComponent } from 'app/rater/rater-assessment-instructions/rater-assessment-instructions.component';
import { RaterAssessmentComponent } from 'app/rater/rater-assessment/rater-assessment.component';
import { PendingAssessmentsComponent } from 'app/client/pending-assessments/pending-assessments.component';
import { CompletedAssessmentsComponent } from 'app/client/completed-assessments/completed-assessments.component';
import { EmailTemplatesComponent } from 'app/admin/email-templates/email-templates.component';
import { NewEmailTemplateComponent } from 'app/admin/new-email-template/new-email-template.component';
import { PredefinedEmailTemplatesComponent } from 'app/coach/predefined-email-templates/predefined-email-templates.component';
import { EmailTemplateComponent } from 'app/coach/email-template/email-template.component';
import { AssessmentEliComponent } from 'app/admin/assessment-eli/assessment-eli.component';
import { Assessment360Component } from 'app/admin/assessment-360/assessment-360.component';
import { NewEliAssessmentComponent } from 'app/admin/new-eli-assessment/new-eli-assessment.component';
import { New360AssessmentComponent } from 'app/admin/new-360-assessment/new-360-assessment.component';
import { DataVisualizerComponent } from 'app/admin/data-visualizer/data-visualizer.component';
import { BiDashboardComponent } from 'app/admin/bi-dashboard/bi-dashboard.component';
import { Section1Component } from 'app/admin/section1/section1.component';
import { Section2Component } from 'app/admin/section2/section2.component';
import { CustomComponent } from 'app/coach/custom/custom.component';
import { ProfileComponent } from 'app/coach/profile/profile.component';
import { AssignedComponent } from 'app/coach/assigned/assigned.component';
import { CoachCompletedAssessmentsComponent } from 'app/coach/completed-assessments/completed-assessments.component';
import { ClientsComponent } from 'app/coach/clients/clients.component';
import { AssignedRatersComponent } from 'app/coach/assigned-raters/assigned-raters.component';
import { CoachDirectoryComponent } from 'app/client/coach-directory/coach-directory.component';
import { LoginComponent } from 'app/login/login.component';
import { DashboardComponent } from 'app/dashboard/dashboard.component';
import { DataVisualizerResultsComponent } from 'app/admin/data-visualizer-results/data-visualizer-results.component';
import { EnergyLeadershipComponent } from 'app/client/energy-leadership/energy-leadership.component';
import { AssessmentReportComponent } from 'app/client/assessment-report/assessment-report.component';
import { CoachAssessmentReportComponent } from 'app/coach/assessment-report/assessment-report.component';
import { AssessmentReport360Component } from 'app/coach/assessment-report-360/assessment-report-360.component';
import { AssignedAssessmentComponent } from 'app/client/assigned-assessment/assigned-assessment.component';
import { AuthGuardService } from 'app/services/guard/auth-guard.service';
import { AdminGuardService } from 'app/services/guard/admin-guard.service';
import { CoachGuardService } from 'app/services/guard/coach-guard.service';
import { ClientGuardService } from 'app/services/guard/client-guard.service';
import { RaterGuardService } from 'app/services/guard/rater-guard.service';
import { AssessmentRefreshGuardService } from 'app/services/guard/assessment-refresh-guard.service';
import { AccountActivationComponent } from 'account-activation/account-activation/account-activation.component';
import { NewEmailTemplateComponentCopy1 } from './admin/new-email-template-Copy/new-email-template.component';
import { CoachAssessmentsComponent } from './coach/assessments/assessments.component';
import { CoachEmailsComponent } from './coach/coach-emails/coach-emails.component';
import { NewCoachEmailTemplateComponent } from './coach/new-coach-email-template/new-coach-email-template.component';
import { RaterAssessmentsComponent } from './rater/rater-assessments/rater-assessments.component';
import { AssessmentSectionsComponent } from './admin/assessment-sections/assessment-sections.component';
import { BusinessInteligenceComponent } from './admin/business-inteligence/business-inteligence.component';
import { Sections360Component } from './admin/sections360/sections360.component';
import { AssessmentComponent } from 'assessment/assessment.component';
import { RaterTakeAssessmentComponent } from 'rater-assessment/rater-assessment.component';
import { CoachDashboardComponent } from './coach/coach-dashboard/coach-dashboard.component';
import { RaterTypesComponent } from './admin/rater-types/rater-types.component';
import { CRaterTypesComponent } from './coach/c-rater-types/c-rater-types.component';
import { CoachHomeComponent } from './coach/home/home.component';
import { AnnouncementsComponent } from './admin/announcements/announcements.component';
import { AssessmentDetailsComponent } from './coach/assessmentDetails/assessmentDetails';
import { ClientProfileComponent } from './client/profile/profile.component';
import { LogComponent } from './admin/log/log.component';
import { EditClientComponent } from './coach/edit-client/edit-client.component';
import { ResetPasswordComponent } from 'reset-password/reset-password.component';
import { AssessmentErrorPageComponent } from 'assessment-error-page/assessment-error-page.component';
import { TabsComponent } from './coach/tabs/tabs.component';
import { LoggedOutPageComponent } from '../logged-out-page/logged-out-page.component';
import { TutorialComponent } from './coach/tutorial/tutorial.component';
import { UsersComponent } from './admin/users/users.component';
import { SsoComponent } from '../sso/sso.component';
import { AssessmentsModlllComponent } from './coach/assessments-mod-lll/assessments-mod-lll.component';
import { AdminDasboardComponent } from './admin/admin-dasboard/admin-dasboard.component';
import { UserPersonalDataComponent } from './admin/user-personal-data/user-personal-data.component';
import { CheckResetPasswordCodeResolverService } from 'reset-password/resolver/check-reset-password-code-resolver.service';
import { RaterLoginComponent } from './rater-login/rater-login.component';
import { AccessibleSelfAssessmentComponent } from '../accessible-self-assessment/accessible-self-assessment.component';
import { ChangeEnvironmentComponent } from './change-environment/change-environment.component';
import { ChangeEnvironmentResolverService } from './change-environment/resolver/change-environment-resolver.service';
import { DuplicateUsersComponent } from './admin/duplicate-users/duplicate-users.component';
import { AssessmentsModIComponent } from './admin/assessments-mod-i/assessments-mod-i.component';

const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: '', redirectTo: '/login', pathMatch: 'full' }, // default path
    { path: 'MK', redirectTo: 'MK1', pathMatch: 'full'}, // RETO-COMPATIBILITY (rater login link | redirect old client's assessment link )
    { path: 'MK1', component: AssessmentComponent },
    { path: 'MK2', component: RaterLoginComponent },
    {
        path: 'ASSESSMENT/DETAILS/:assignmentId', component: AssessmentDetailsComponent
    }, {
        path: 'ASSESSMENT/RESULTS/:assignmentId/:userType', component: AssessmentDetailsComponent
    },
    {
        path: 'RATER/ASSESSMENT/:id', component: RaterTakeAssessmentComponent
    },
    {
        path: 'RESETPASSWORD/:id/:code', component: ResetPasswordComponent, resolve: {resolveData: CheckResetPasswordCodeResolverService}
    },
    {
        path: 'ASSESSMENTERRORPAGE', component: AssessmentErrorPageComponent
    },
    {
        path: 'LOGGEDOUT', component: LoggedOutPageComponent
    },
    {
        path: 'sso/:token', component: SsoComponent
    },
    {
        path: 'rater/login', component: RaterLoginComponent
    },
    {
        path: 'changeEnvironment/:announcements/:token/:fullName/:userId/:userType/:userMode/:modes/:email/:canEditEmail/:NR9/:hasBetaAccess/:environment', component: ChangeEnvironmentComponent, resolve: {data: ChangeEnvironmentResolverService}
    },

         // for 360 assessments
    { path: 'assigned_assessment/:from/:id/:assignmentId/:name/:language/:fullName', component: AssignedAssessmentComponent}, // for raters
    {
/*        path: 'accessibleSelfAssessment/:from/:id/:assignmentId/:name/:language', component: AccessibleSelfAssessmentComponent*/
        path: 'accessibleSelfAssessment/:id', component: AccessibleSelfAssessmentComponent
    },
    {
        path: 'app', component: DashboardComponent, canActivate: [AuthGuardService],
        children: [
            { path: '', redirectTo: 'app', pathMatch: 'full' },
            // url set by the assigned assessment (pushState), it is only reached when the page is refreshed
            { path: 'assessment', canActivate: [AssessmentRefreshGuardService], children: [] },
            { path: '**', redirectTo: 'app' },
            { path: 'user', component: UserComponent },
            { path: 'table', component: TablesComponent },
            { path: 'typography', component: TypographyComponent },
            { path: 'icons', component: IconsComponent },
            { path: 'maps', component: MapsComponent },
            { path: 'notifications', component: NotificationsComponent },
            { path: 'upgrade', component: UpgradeComponent },

            // admin
            { path: 'niches', component: NichesComponent, canActivate: [AdminGuardService]},
            { path: 'questions', component: QuestionsComponent, canActivate: [AdminGuardService] },
            { path: 'regular', component: RegularComponent, canActivate: [AdminGuardService] },
            { path: 'satisfaction', component: SatisfactionComponent, canActivate: [AdminGuardService] },
            { path: 'survey', component: SurveyComponent, canActivate: [AdminGuardService] },
            { path: 'assessments', component: AssessmentsComponent, canActivate: [AdminGuardService] },
            { path: 'emailtemplates', component: EmailTemplatesComponent, canActivate: [AdminGuardService] },
            { path: 'newemailtemplateWomla', component: NewEmailTemplateComponent, canActivate: [AdminGuardService] },
            { path: 'newemailtemplate', component: NewEmailTemplateComponentCopy1, canActivate: [AdminGuardService] },
            { path: 'edit_emailtemplate/:id', component: NewEmailTemplateComponentCopy1, canActivate: [AdminGuardService] },
            { path: 'eli', component: AssessmentEliComponent, canActivate: [AdminGuardService] },
            { path: '360', component: Assessment360Component, canActivate: [AdminGuardService] },
            { path: 'edit_eli/:id', component: NewEliAssessmentComponent, canActivate: [AdminGuardService] }, // edit
            { path: 'neweli', component: NewEliAssessmentComponent, canActivate: [AdminGuardService] }, // new
            { path: 'edit_360/:id', component: New360AssessmentComponent, canActivate: [AdminGuardService] }, // edit
            { path: 'new360', component: New360AssessmentComponent, canActivate: [AdminGuardService] }, // new
            { path: 'datavisualizer', component: DataVisualizerComponent, canActivate: [AdminGuardService] },
            { path: 'sections_360', component: Sections360Component, canActivate: [AdminGuardService] },
            { path: 'section1', component: Section1Component, canActivate: [AdminGuardService] },
            { path: 'section2', component: Section2Component, canActivate: [AdminGuardService] },
            { path: 'dv_results', component: DataVisualizerResultsComponent, canActivate: [AdminGuardService] },
            { path: 'assessments_sections', component: AssessmentSectionsComponent, canActivate: [AdminGuardService] },
            { path: 'business_inteligence', component: BusinessInteligenceComponent, canActivate: [AdminGuardService] },
            { path: 'rater_types', component: RaterTypesComponent, canActivate: [AdminGuardService] },
            { path: 'announcements', component: AnnouncementsComponent, canActivate: [AdminGuardService] },
            { path: 'users', component: UsersComponent, canActivate: [AdminGuardService] },
            { path: 'duplicate_users', component: DuplicateUsersComponent, canActivate: [AdminGuardService] },
            { path: 'assessments_mod_i', component: AssessmentsModIComponent, canActivate: [AdminGuardService] },
            { path: 'assessments_mod_lll', component: AssessmentsModlllComponent, canActivate: [AdminGuardService] },
            { path: 'error_log', component: LogComponent, canActivate: [AdminGuardService] },
            { path: 'admin_dashboard', component: AdminDasboardComponent, canActivate: [AdminGuardService] },
            { path: 'user_personal_data/:id', component: UserPersonalDataComponent, canActivate: [AdminGuardService] },

            // coach
            { path: 'coach_home', component: CoachHomeComponent, canActivate: [CoachGuardService] },
            { path: 'unassigned', component: UnassignedAssessmentsComponent, canActivate: [CoachGuardService] },
            { path: 'assigned', component: AssignedComponent, canActivate: [CoachGuardService] },
            { path: 'assigned_raters', component: AssignedRatersComponent, canActivate: [CoachGuardService] },
            { path: 'ccompleted', component: CoachCompletedAssessmentsComponent, canActivate: [CoachGuardService] },
            { path: 'coach_assessments', component: CoachAssessmentsComponent, canActivate: [CoachGuardService] },
            { path: 'clients', component: ClientsComponent, canActivate: [CoachGuardService] },
            { path: 'edit_clients/:clientId/:email/:name/:last/:status', component: EditClientComponent, canActivate: [CoachGuardService] },
            { path: 'predefined', component: PredefinedEmailTemplatesComponent, canActivate: [CoachGuardService] },
            { path: 'emailtemplate', component: EmailTemplateComponent, canActivate: [CoachGuardService] },
            { path: 'custom', component: CustomComponent, canActivate: [CoachGuardService] },
            { path: 'custom', component: CustomComponent, canActivate: [CoachGuardService] },
            { path: 'cemails', component: CoachEmailsComponent, canActivate: [CoachGuardService] },
            { path: 'cemails/:templateType/:templateSubType', component: CoachEmailsComponent, canActivate: [CoachGuardService] },
            { path: 'tabs', component: TabsComponent, canActivate: [CoachGuardService] },
            { path: 'new_coach_email_template', component: NewCoachEmailTemplateComponent, canActivate: [CoachGuardService] },
            {
                path: 'edit_coach_email_template/:id/:isStandard',
                component: NewCoachEmailTemplateComponent, canActivate: [CoachGuardService] },
            { path: 'profile', component: ProfileComponent, canActivate: [CoachGuardService] },
            { path: 'co_a_report_360', component: AssessmentReport360Component, canActivate: [CoachGuardService] },
            { path: 'bidashboard', component: BiDashboardComponent, canActivate: [CoachGuardService] },
            { path: 'coachDashboard', component: CoachDashboardComponent, canActivate: [CoachGuardService] },
            { path: 'c_rater_types', component: CRaterTypesComponent, canActivate: [CoachGuardService] },
            { path: 'tutorial/:index', component: TutorialComponent, canActivate: [CoachGuardService] },

            // client
            { path: 'client_assessments', component: ClientAssessmentsComponent, canActivate: [ClientGuardService] },
            { path: 'reports', component: ClientReportsComponent, canActivate: [ClientGuardService] },
            { path: 'pending', component: PendingAssessmentsComponent, canActivate: [ClientGuardService] },
            { path: 'completed', component: CompletedAssessmentsComponent, canActivate: [ClientGuardService] },
            { path: 'coach_directory', component: CoachDirectoryComponent, canActivate: [ClientGuardService]},
            { path: 'energy_leadership', component: EnergyLeadershipComponent, canActivate: [ClientGuardService] },
            { path: 'c_a_report/:assignmentId', component: AssessmentReportComponent, canActivate: [ClientGuardService] },
            {
                path: 'co_a_report/:assignmentId/:from/:showGenerateResults',
                component: CoachAssessmentReportComponent, canActivate: [ClientGuardService] },
            { path: 'client_profile', component: ClientProfileComponent, canActivate: [ClientGuardService] },

            // multiple
            { path: 'help', component: HelpComponent },

            // rater
            { path: 'rater_assessments', component: RaterAssessmentsComponent, canActivate: [RaterGuardService] },
            { path: 'rinstructions', component: RaterAssessmentInstructionsComponent, canActivate: [RaterGuardService] },
            { path: 'rinstructions/:id', component: RaterAssessmentInstructionsComponent, canActivate: [RaterGuardService] },
            { path: 'rassessment/:id', component: RaterAssessmentComponent, canActivate: [RaterGuardService] },

            {
                path: 'instructions/:from/:assignmentId/:name',
                component: InstructionsComponent, canActivate: [RaterGuardService]
            }, // for rater invitation link
            { path: 'instructions/:from/:id/:assignmentId', component: InstructionsComponent, canActivate: [RaterGuardService] },
            {
                path: 'instructions/:from/:id/:assignmentId/:name', component: InstructionsComponent,
                canActivate: [RaterGuardService]
            }, // id = assessmentId, => this router link is for client invitation link

            // for regular assessments
            {
                path: 'assigned_assessment/:from/:id/:assignmentId/:name/:language',
                component: AssignedAssessmentComponent, canActivate: [RaterGuardService]
            }, // for clients
            // for 360 assessments
            {
                path: 'assigned_assessment/:from/:id/:assignmentId/:name/:language/:fullName',
                component: AssignedAssessmentComponent}, // for raters

            { path: 'assigned_assessment/:from/:assignmentId', component: AssignedAssessmentComponent, canActivate: [RaterGuardService] },
            { path: 'account_activation', component: AccountActivationComponent },
        ]
    },

];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
